export const authorizationSystemTypes = [{
  id: 0,
  title: 'غیر سیستمی'
},
{
  id: 2,
  title: 'اعتبارسنجی ایران'
},
{
  id: 4,
  title: 'بتا بانک رفاه'
},
{
  id: 5,
  title: 'قرارداد امضا دیجیتال - پیامکی'
},
{
  id: 6,
  title: 'قراداد ضامن با امضا پیامکی'
},
{
  id: 7,
  title: 'قرارداد امضا دیجیتال - امضامی'
},
{
  id: 10,
  title: 'احراز هویت'
},
{
  id: 12,
  title: 'وریفای شماره موبایل'
},
{
  id: 15,
  title: 'تطابق کدملی و شماره موبایل'
},
{
  id: 16,
  title: 'تطابق کد ملی و شماره موبایل و تاریخ تولد و شبا'
},
{
  id: 17,
  title: 'استعلام ثنا'
},
{
  id: 18,
  title: 'استعلام چک برگشتی'
},
{
  id: 19,
  title: 'استعلام خدمت سربازی'
},
{
  id: 30,
  title: 'استعلام تسهیلات بانکی'
}
]

export const babats = [
  { id: "HOGHOGH", title: "واریز حقوق" },
  { id: "BIME", title: "امور بیمه خدمات" },
  { id: "DARMANI", title: "امور درمانی" },
  { id: "BOURS", title: "امور سرمایه گذاری و بورس" },
  { id: "ARZ", title: "امور ارزی در چارچوب ضوابط و مقررات" },
  { id: "GHARZ_AND_DION", title: "پرداخت قرض و تادیه دیون (قرض الحسنه، بدهی)" },
  { id: "BAZNESHASTEGI", title: "امور بازنشستگی" },
  { id: "MOAMELAT_MANGHOL", title: "معاملات اموال منقول" },
  { id: "MOAMELAT_GHEIR_MANGHOOL", title: "معاملات اموال غیر منقول" },
  { id: "NAGHDINEGI", title: "مدیریت نقدینگی" },
  { id: "GOMROK", title: "عوارض گمرکی" },
  { id: "MALIAT", title: "تسویه مالیاتی" },
  { id: "DOWLATI", title: "سایر خدمات دولتی" },
  { id: "TASHILAT", title: "تسهیلات و تعهدات" },
  { id: "VASIGHE", title: "تودیع وثیقه" },
  { id: "OMUMI", title: "هزینه عمومی و امور روزمره" },
  { id: "KHEIRIEH", title: "کمک‌های خیریه" },
  { id: "KALA", title: "خرید کالا" },
  { id: "KHADAMAT", title: "خرید خدمات" }
]

export const banks = [
  { id: "ENB", title: "بانک اقتصاد نوین" },
  { id: "ANS", title: "بانک انصار" },
  { id: "IRZ", title: "بانک ایران زمین" },
  { id: "PAR", title: "بانک پارسیان" },
  { id: "PAS", title: "بانک پاسارگاد" },
  { id: "TEJ", title: "بانک تجارت" },
  { id: "BTT", title: "بانک توسعه تعاون" },
  { id: "BTS", title: "بانک توسعه صادرات ایران" },
  { id: "HEK", title: "بانک حکمت ایرانیان" },
  { id: "KHMI", title: "بانک خاورمیانه" },
  { id: "DEY", title: "بانک دی" },
  { id: "REF", title: "بانک رفاه" },
  { id: "SAM", title: "بانک سامان" },
  { id: "BSP", title: "بانک سپه" },
  { id: "SAR", title: "بانک سرمایه" },
  { id: "SIN", title: "بانک سینا" },
  { id: "SHR", title: "بانک شهر" },
  { id: "BSI", title: "بانک صادرات ایران" },
  { id: "BSM", title: "بانک صنعت و معدن" },
  { id: "RES", title: "بانک قرض‌الحسنه رسالت" },
  { id: "MHR", title: "بانک قرض‌الحسنه مهر ایران" },
  { id: "GHA", title: "بانک قوامین" },
  { id: "BKA", title: "بانک کارآفرین" },
  { id: "BKV", title: "بانک کشاورزی ایران" },
  { id: "GAR", title: "بانک گردشگری" },
  { id: "BMK", title: "بانک مسکن" },
  { id: "MEL", title: "بانک ملت" },
  { id: "BMI", title: "بانک ملی ایران" },
  { id: "NOR", title: "بانک نور" },
  { id: "PST", title: "پست بانک" },
  { id: "MEH", title: "بانک مهر اقتصاد" }
]

export const transferTypes = [
  { id: "LOCAL", title: "صادرات به صادرات" },
  { id: "PAYA", title: "پایا" },
  { id: "SATNA", title: "ساتنا" },
  { id: "POL", title: "پل" }
]





export const sponsorStatuses = [
  { id: 0, title: 'در انتظار بررسی' },
  { id: 5, title: 'نقص مدارک' },
  { id: 10, title: 'تکمیل مدارک شده توسط مشتری' },
  { id: 15, title: 'در حال پیگیری' },
  { id: 20, title: 'رد شده' },
  { id: 25, title: 'تایید شده' },
  { id: 30, title: 'اعطا شده' },
]

export const siteContentKeys = {
  NafisSlider1: 'Nafis_Slider1',
  NafisCorporators: 'Nafis_Corporators',
  NafisSection1: 'Nafis_Section1',
  NafisComments: 'Nafis_Comments',
  DefaulTopSection: 'Default_TopSection'
}

export const smsReplacePattern = {
				'{نام مشتری}': 'مهدی قاسمی فرد',
				'{نام فروشگاه}': 'فروشگاه قاسمی فرد',
				'{مبلغ قسط}': 5500000,
				'{مبلغ مانده قسط}': 4500000,
				'{شماره قسط}': 5,
				'{مبلغ واریز}': 5500000,
				'{مبلغ آخرین واریز}': 5500000,
				'{تاریخ واریز}': '1405-01-30',
				'{مانده وام}': 65000000,
				'{لینک پرداخت}': 'https://domain.ir/pop/100/1323213',
				'{بخش متغیر لینک پرداخت}': '100/1323213',
				'{مبلغ هر قسط}': 5000000,
				'{مبلغ درخواستی}': 20000000,
				'{تعداد قسط}': 12,
				'{تاریخ درخواست}': '1405-03-05',
				'{نوع وام}': 'طرح بدون ضامن',
				'{شماره درخواست}': 1000,
				'{تاریخ تغییر وضعیت}': '1405-05-05',
				'{نام نماینده}': 'فروشگاه ما',
				'{وضعیت جدید}': 'اعطا شده',
				'{وضعیت جدید نماینده}': 'تسویه شده',
				'{سررسید واریز نماینده}': '1405-05-10',
				'{توسط نماینده با لیبل}': 'توسط نماینده داتیس',
				'{شماره پیگیری تراکنش}': '115100022233200',
				'{نام و نام خانوادگی}': 'محمد محمدی',
				'{نام کاربری}': 'admin',
				'{تاریخ}': '1405-05-05',
				'{تاریخ و ساعت}': '1405-05-05 10:15:06',
				'{تاریخ و ساعت درخواست}': '1405-05-05 10:15:06',
				'{آی پی}': '5.192.78.201',
				'{مرورگر}': 'chrome',
				'{رمز تاییدیه}': '54568',
				'{مبلغ باقیمانده}': 2500000,
				'{تعداد اقساط}': 12,
				'{بازپرداخت با بهره}': 27000000,
				'{مبلغ وام}': 25000000,
				'{تاریخ شروع}': '1404-05-01',
				'{شماره وام}': 102,
				'{کد تائیدیه}': 10562,
				'{مبلغ}': 650000000,
				'{تاریخ}': '1404-05-01',
				'{مانده اعتبار کیف پول}': 20000000,
				'{کد رهگیری}': '120002',
				'{نام تجاری نماینده}': 'بازرگانی قاسمی فرد',
				'{کد ملی مشتری}': '00315641656',
				'{نام طرح وام}': 'طرح تسهیلات فوری',
				'{مبلغ درخواست وام}': 250000000,
				'{لینک قرارداد}': 'https://domain.ir/dgs/100/1213',
				'{بخش متغیر لینک قرارداد}': '/dgs/100/1213',
				'{نام و نام خانوادگی ضامن}': 'محمد محمدی',
				'{کد ملی ضامن}': '3215650002',
				'{موبایل ضامن}': '09333333333',
				'{وضعیت درخواست}': 'در انتظار بررسی کارشناس',
			}

export const smsCategories = [
				{ value: 0, title: 'قسط' },
				{ value: 1, title: 'تغییر وضعیت' },
				{ value: 2, title: 'ورود به پنل' },
				{ value: 3, title: 'ثبت نام' },
				{ value: 4, title: 'کد تاییدیه ثبت نام' },
				{ value: 5, title: 'شارژ کیف پول' },
				{ value: 6, title: 'ثبت سفارش جدید' },
				{ value: 7, title: 'ثبت پرونده' },
				{ value: 8, title: 'برداشت از کیف پول' },
				{ value: 9, title: 'لینک واریز صورتحساب الکترونیکی' },
				{ value: 10, title: 'لینک قرارداد' },
				{ value: 11, title: 'کد تاییدیه قرارداد' },
				{ value: 12, title: 'اطلاعیه ثبت موفق قرارداد' },
				{ value: 13, title: 'کد تاییدیه قرارداد ضامن' },
				{ value: 14, title: 'لینک قرارداد ضامن' },
				{ value: 15, title: 'اطلاعیه ثبت موفق قرارداد ضامن' },
				{ value: 16, title: 'اطلاعیه درخواست وام جدید' },
			]

export const siteContentRootPath = '/siteContents/'
